<button
  class="link-button {{ btnClass }}"
  (click)="onClick($event)"
  [disabled]="disabled"
  [ngClass]="ngClass"
  [type]="type"
  [attr.aria-label]="ariaLabel || null"
>
  <fa-icon
    *ngIf="fontSet && fontIcon && iconSide === 'left'"
    [icon]="[fontSet, fontIcon]"
    class="mr-2"
  >
  </fa-icon>

  @if (text) {
    <span>{{ text }}</span>
  }
  @if (hiddenText) {
    <span class="cdk-visually-hidden">{{ hiddenText }}</span>
  }

  <fa-icon
    *ngIf="fontSet && fontIcon && iconSide === 'right'"
    [icon]="[fontSet, fontIcon]"
    class="ml-2"
  >
  </fa-icon>
</button>
